import { render, staticRenderFns } from "./broadside.vue?vue&type=template&id=1bfa5e08&scoped=true"
import script from "./broadside.vue?vue&type=script&lang=js"
export * from "./broadside.vue?vue&type=script&lang=js"
import style0 from "./broadside.vue?vue&type=style&index=0&id=1bfa5e08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bfa5e08",
  null
  
)

export default component.exports